
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[...url]",
      function () {
        return require("private-next-pages/services/[...url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[...url]"])
      });
    }
  